/**
 * Gateway V1 ABI — the generation live on Polygon mainnet today.
 *
 * Kept because the app must keep working against V1 until V2 activates.
 * Decoding a V1 `getUser` return through the V2 ABI throws outright
 * ("Position 671 is out of bounds"), so this is not a nicety.
 */
export const GATEWAY_ABI_V1 = [
  {
    inputs: [
      { internalType: "address", name: "token_1", type: "address" },
      { internalType: "address", name: "token_2", type: "address" },
      { internalType: "address", name: "_dao", type: "address" },
      { internalType: "address", name: "_calculator", type: "address" },
      { internalType: "address", name: "dnm_contract", type: "address" },
      {
        internalType: "uint256",
        name: "dnm_user_current_reward",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "dnm_seller_current_reward",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "dnm_voucher_current_reward",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  { inputs: [], name: "DevTimeOver", type: "error" },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "InvalidAmount",
    type: "error",
  },
  {
    inputs: [{ internalType: "uint256", name: "fromId", type: "uint256" }],
    name: "InvalidFromID",
    type: "error",
  },
  { inputs: [], name: "InvalidPayment", type: "error" },
  {
    inputs: [
      { internalType: "uint256", name: "fromId", type: "uint256" },
      { internalType: "uint256", name: "toId", type: "uint256" },
    ],
    name: "InvalidRangeID",
    type: "error",
  },
  {
    inputs: [{ internalType: "uint256", name: "toId", type: "uint256" }],
    name: "InvalidToID",
    type: "error",
  },
  { inputs: [], name: "MintDNMError", type: "error" },
  { inputs: [], name: "OnlyDao", type: "error" },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "OwnableInvalidOwner",
    type: "error",
  },
  {
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "OwnableUnauthorizedAccount",
    type: "error",
  },
  {
    inputs: [
      { internalType: "address", name: "parent_address", type: "address" },
      { internalType: "uint256", name: "user_id", type: "uint256" },
    ],
    name: "ParentNotExist",
    type: "error",
  },
  { inputs: [], name: "PaymentError", type: "error" },
  { inputs: [], name: "ReentrancyGuardReentrantCall", type: "error" },
  {
    inputs: [{ internalType: "uint256", name: "seller_id", type: "uint256" }],
    name: "SellerNotFound",
    type: "error",
  },
  { inputs: [], name: "TransferError", type: "error" },
  { inputs: [], name: "UserNotFound", type: "error" },
  { inputs: [], name: "Wait45Days", type: "error" },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "seller_addr",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "added_volume",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "current_bv",
        type: "uint256",
      },
    ],
    name: "AddedSaleVolume",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "user_id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "order_id",
        type: "uint256",
      },
    ],
    name: "Calculated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "user_id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "week_number",
        type: "uint256",
      },
    ],
    name: "CalculatedWeek",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint256", name: "id", type: "uint256" },
      {
        indexed: true,
        internalType: "address",
        name: "seller_addr",
        type: "address",
      },
    ],
    name: "CreatedSeller",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user_address",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "user_id",
        type: "uint256",
      },
    ],
    name: "CreatedUser",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "user_id",
        type: "uint256",
      },
      { indexed: true, internalType: "uint256", name: "date", type: "uint256" },
      {
        indexed: true,
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    name: "LevelUp",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint256", name: "id", type: "uint256" },
      {
        indexed: true,
        internalType: "uint256",
        name: "seller_id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "user_id",
        type: "uint256",
      },
    ],
    name: "NewOrderEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "BVPlan",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DNM_SELLER_CURRENT_REWARD",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DNM_SELLER_MAX_REWARD",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DNM_USER_CURRENT_REWARD",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DNM_USER_MAX_REWARD",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DNM_VOUCHER_CURRENT_REWARD",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DNM_VOUCHER_MAX_REWARD",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DnmTokenAddress",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "ListLevelUpDate",
    outputs: [
      { internalType: "uint256", name: "date", type: "uint256" },
      { internalType: "uint256", name: "level", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "OrderList",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "uint256", name: "user_id", type: "uint256" },
      { internalType: "uint256", name: "seller_id", type: "uint256" },
      { internalType: "uint256", name: "bv_value", type: "uint256" },
      { internalType: "uint256", name: "sv_value", type: "uint256" },
      { internalType: "uint256", name: "seller_token", type: "uint256" },
      { internalType: "uint256", name: "date", type: "uint256" },
      { internalType: "bytes32", name: "data", type: "bytes32" },
      { internalType: "bool", name: "exists", type: "bool" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "SellerAddress",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "SellerList",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      { internalType: "address", name: "seller_addr", type: "address" },
      { internalType: "uint256", name: "bv_value", type: "uint256" },
      {
        internalType: "uint256",
        name: "token_withdraw_value",
        type: "uint256",
      },
      { internalType: "uint256", name: "dnm_withdraw", type: "uint256" },
      { internalType: "bool", name: "exists", type: "bool" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "Token1",
    outputs: [{ internalType: "contract IERC20", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "Token2",
    outputs: [{ internalType: "contract IERC20", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "UserAddress",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "", type: "uint256" },
      { internalType: "uint256", name: "", type: "uint256" },
    ],
    name: "UserLevelUpDateIndex",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "UserList",
    outputs: [
      { internalType: "uint256", name: "id", type: "uint256" },
      {
        components: [
          { internalType: "uint256", name: "left", type: "uint256" },
          { internalType: "uint256", name: "right", type: "uint256" },
          { internalType: "uint256", name: "all_left", type: "uint256" },
          { internalType: "uint256", name: "all_right", type: "uint256" },
          { internalType: "uint256", name: "dir", type: "uint256" },
          { internalType: "uint256", name: "level", type: "uint256" },
          { internalType: "uint256", name: "summ", type: "uint256" },
          { internalType: "uint256", name: "dnm_withdraw", type: "uint256" },
        ],
        internalType: "struct UsersStruct.BusinessValue",
        name: "bv",
        type: "tuple",
      },
      {
        components: [
          { internalType: "uint256", name: "date", type: "uint256" },
          { internalType: "uint256", name: "order_id", type: "uint256" },
          { internalType: "uint256", name: "bv_level", type: "uint256" },
        ],
        internalType: "struct UsersStruct.LastOrder",
        name: "last_order",
        type: "tuple",
      },
      { internalType: "uint256", name: "depth", type: "uint256" },
      { internalType: "uint256", name: "pending_withdraw", type: "uint256" },
      { internalType: "uint256", name: "levelup_count", type: "uint256" },
      { internalType: "uint256", name: "lastweek", type: "uint256" },
      { internalType: "uint256", name: "step", type: "uint256" },
      { internalType: "uint256", name: "pending_voucher", type: "uint256" },
      { internalType: "bool", name: "exists", type: "bool" },
      { internalType: "bytes32", name: "data", type: "bytes32" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "", type: "uint256" },
      { internalType: "uint256", name: "", type: "uint256" },
    ],
    name: "UsersPaths",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "", type: "uint256" },
      { internalType: "uint256", name: "", type: "uint256" },
    ],
    name: "UsersPathsHash",
    outputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint256", name: "left", type: "uint256" },
          { internalType: "uint256", name: "right", type: "uint256" },
          { internalType: "uint256", name: "allLeft", type: "uint256" },
          { internalType: "uint256", name: "allRight", type: "uint256" },
          { internalType: "uint256", name: "bv_level", type: "uint256" },
          { internalType: "address", name: "user_address", type: "address" },
          { internalType: "address", name: "parent_address", type: "address" },
          { internalType: "uint256", name: "level_up_date", type: "uint256" },
        ],
        internalType: "struct UsersStruct.ImportUser[]",
        name: "users",
        type: "tuple[]",
      },
    ],
    name: "addUserBulk",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256[]", name: "ordersId", type: "uint256[]" },
    ],
    name: "calculate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "calculateWeek",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "calculator",
    outputs: [
      { internalType: "contract Calculator", name: "", type: "address" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "daoAddr", type: "address" }],
    name: "changeDao",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "wallet_address", type: "address" },
    ],
    name: "changeFeeWallet",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "dao",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeWallet",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "a", type: "uint256" },
      { internalType: "uint256", name: "b", type: "uint256" },
    ],
    name: "floor",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "spender", type: "address" },
    ],
    name: "getAllowance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "bytes1", name: "b", type: "bytes1" },
      { internalType: "uint8", name: "position", type: "uint8" },
    ],
    name: "getBit",
    outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_order_id", type: "uint256" }],
    name: "getOrderList",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "user_id", type: "uint256" },
          { internalType: "uint256", name: "seller_id", type: "uint256" },
          { internalType: "uint256", name: "bv_value", type: "uint256" },
          { internalType: "uint256", name: "sv_value", type: "uint256" },
          { internalType: "uint256", name: "seller_token", type: "uint256" },
          { internalType: "uint256", name: "date", type: "uint256" },
          { internalType: "bytes32", name: "data", type: "bytes32" },
          { internalType: "bool", name: "exists", type: "bool" },
        ],
        internalType: "struct OrdersStruct.Order",
        name: "order",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "fromId", type: "uint256" },
      { internalType: "uint256", name: "toId", type: "uint256" },
    ],
    name: "getOrderLists",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "uint256", name: "user_id", type: "uint256" },
          { internalType: "uint256", name: "seller_id", type: "uint256" },
          { internalType: "uint256", name: "bv_value", type: "uint256" },
          { internalType: "uint256", name: "sv_value", type: "uint256" },
          { internalType: "uint256", name: "seller_token", type: "uint256" },
          { internalType: "uint256", name: "date", type: "uint256" },
          { internalType: "bytes32", name: "data", type: "bytes32" },
          { internalType: "bool", name: "exists", type: "bool" },
        ],
        internalType: "struct OrdersStruct.Order[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_seller_id", type: "uint256" },
      { internalType: "bool", name: "ignore_vaildation", type: "bool" },
    ],
    name: "getSeller",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "address", name: "seller_addr", type: "address" },
          { internalType: "uint256", name: "bv_value", type: "uint256" },
          {
            internalType: "uint256",
            name: "token_withdraw_value",
            type: "uint256",
          },
          { internalType: "uint256", name: "dnm_withdraw", type: "uint256" },
          { internalType: "bool", name: "exists", type: "bool" },
        ],
        internalType: "struct Sellers.Seller",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "fromId", type: "uint256" },
      { internalType: "uint256", name: "toId", type: "uint256" },
    ],
    name: "getSellerList",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "id", type: "uint256" },
          { internalType: "address", name: "seller_addr", type: "address" },
          { internalType: "uint256", name: "bv_value", type: "uint256" },
          {
            internalType: "uint256",
            name: "token_withdraw_value",
            type: "uint256",
          },
          { internalType: "uint256", name: "dnm_withdraw", type: "uint256" },
          { internalType: "bool", name: "exists", type: "bool" },
        ],
        internalType: "struct Sellers.Seller[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_user_id", type: "uint256" },
      { internalType: "bool", name: "ignore_validation", type: "bool" },
    ],
    name: "getUser",
    outputs: [
      { internalType: "address", name: "", type: "address" },
      {
        components: [
          { internalType: "uint256", name: "id", type: "uint256" },
          {
            components: [
              { internalType: "uint256", name: "left", type: "uint256" },
              { internalType: "uint256", name: "right", type: "uint256" },
              { internalType: "uint256", name: "all_left", type: "uint256" },
              { internalType: "uint256", name: "all_right", type: "uint256" },
              { internalType: "uint256", name: "dir", type: "uint256" },
              { internalType: "uint256", name: "level", type: "uint256" },
              { internalType: "uint256", name: "summ", type: "uint256" },
              {
                internalType: "uint256",
                name: "dnm_withdraw",
                type: "uint256",
              },
            ],
            internalType: "struct UsersStruct.BusinessValue",
            name: "bv",
            type: "tuple",
          },
          {
            components: [
              { internalType: "uint256", name: "date", type: "uint256" },
              { internalType: "uint256", name: "order_id", type: "uint256" },
              { internalType: "uint256", name: "bv_level", type: "uint256" },
            ],
            internalType: "struct UsersStruct.LastOrder",
            name: "last_order",
            type: "tuple",
          },
          { internalType: "uint256", name: "depth", type: "uint256" },
          {
            internalType: "uint256",
            name: "pending_withdraw",
            type: "uint256",
          },
          { internalType: "uint256", name: "levelup_count", type: "uint256" },
          { internalType: "uint256", name: "lastweek", type: "uint256" },
          { internalType: "uint256", name: "step", type: "uint256" },
          { internalType: "uint256", name: "pending_voucher", type: "uint256" },
          { internalType: "bool", name: "exists", type: "bool" },
          { internalType: "bytes32", name: "data", type: "bytes32" },
        ],
        internalType: "struct UsersStruct.User",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "user_address", type: "address" },
    ],
    name: "getUser",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "id", type: "uint256" },
          {
            components: [
              { internalType: "uint256", name: "left", type: "uint256" },
              { internalType: "uint256", name: "right", type: "uint256" },
              { internalType: "uint256", name: "all_left", type: "uint256" },
              { internalType: "uint256", name: "all_right", type: "uint256" },
              { internalType: "uint256", name: "dir", type: "uint256" },
              { internalType: "uint256", name: "level", type: "uint256" },
              { internalType: "uint256", name: "summ", type: "uint256" },
              {
                internalType: "uint256",
                name: "dnm_withdraw",
                type: "uint256",
              },
            ],
            internalType: "struct UsersStruct.BusinessValue",
            name: "bv",
            type: "tuple",
          },
          {
            components: [
              { internalType: "uint256", name: "date", type: "uint256" },
              { internalType: "uint256", name: "order_id", type: "uint256" },
              { internalType: "uint256", name: "bv_level", type: "uint256" },
            ],
            internalType: "struct UsersStruct.LastOrder",
            name: "last_order",
            type: "tuple",
          },
          { internalType: "uint256", name: "depth", type: "uint256" },
          {
            internalType: "uint256",
            name: "pending_withdraw",
            type: "uint256",
          },
          { internalType: "uint256", name: "levelup_count", type: "uint256" },
          { internalType: "uint256", name: "lastweek", type: "uint256" },
          { internalType: "uint256", name: "step", type: "uint256" },
          { internalType: "uint256", name: "pending_voucher", type: "uint256" },
          { internalType: "bool", name: "exists", type: "bool" },
          { internalType: "bytes32", name: "data", type: "bytes32" },
        ],
        internalType: "struct UsersStruct.User",
        name: "user",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "fromId", type: "uint256" },
      { internalType: "uint256", name: "toId", type: "uint256" },
    ],
    name: "getUserList",
    outputs: [
      {
        components: [
          {
            components: [
              { internalType: "uint256", name: "id", type: "uint256" },
              {
                components: [
                  { internalType: "uint256", name: "left", type: "uint256" },
                  { internalType: "uint256", name: "right", type: "uint256" },
                  {
                    internalType: "uint256",
                    name: "all_left",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "all_right",
                    type: "uint256",
                  },
                  { internalType: "uint256", name: "dir", type: "uint256" },
                  { internalType: "uint256", name: "level", type: "uint256" },
                  { internalType: "uint256", name: "summ", type: "uint256" },
                  {
                    internalType: "uint256",
                    name: "dnm_withdraw",
                    type: "uint256",
                  },
                ],
                internalType: "struct UsersStruct.BusinessValue",
                name: "bv",
                type: "tuple",
              },
              {
                components: [
                  { internalType: "uint256", name: "date", type: "uint256" },
                  {
                    internalType: "uint256",
                    name: "order_id",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "bv_level",
                    type: "uint256",
                  },
                ],
                internalType: "struct UsersStruct.LastOrder",
                name: "last_order",
                type: "tuple",
              },
              { internalType: "uint256", name: "depth", type: "uint256" },
              {
                internalType: "uint256",
                name: "pending_withdraw",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "levelup_count",
                type: "uint256",
              },
              { internalType: "uint256", name: "lastweek", type: "uint256" },
              { internalType: "uint256", name: "step", type: "uint256" },
              {
                internalType: "uint256",
                name: "pending_voucher",
                type: "uint256",
              },
              { internalType: "bool", name: "exists", type: "bool" },
              { internalType: "bytes32", name: "data", type: "bytes32" },
            ],
            internalType: "struct UsersStruct.User",
            name: "user",
            type: "tuple",
          },
          { internalType: "address", name: "user_address", type: "address" },
        ],
        internalType: "struct UsersStruct.UserInfo[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint256", name: "id", type: "uint256" },
          {
            components: [
              { internalType: "uint256", name: "left", type: "uint256" },
              { internalType: "uint256", name: "right", type: "uint256" },
              { internalType: "uint256", name: "all_left", type: "uint256" },
              { internalType: "uint256", name: "all_right", type: "uint256" },
              { internalType: "uint256", name: "dir", type: "uint256" },
              { internalType: "uint256", name: "level", type: "uint256" },
              { internalType: "uint256", name: "summ", type: "uint256" },
              {
                internalType: "uint256",
                name: "dnm_withdraw",
                type: "uint256",
              },
            ],
            internalType: "struct UsersStruct.BusinessValue",
            name: "bv",
            type: "tuple",
          },
          {
            components: [
              { internalType: "uint256", name: "date", type: "uint256" },
              { internalType: "uint256", name: "order_id", type: "uint256" },
              { internalType: "uint256", name: "bv_level", type: "uint256" },
            ],
            internalType: "struct UsersStruct.LastOrder",
            name: "last_order",
            type: "tuple",
          },
          { internalType: "uint256", name: "depth", type: "uint256" },
          {
            internalType: "uint256",
            name: "pending_withdraw",
            type: "uint256",
          },
          { internalType: "uint256", name: "levelup_count", type: "uint256" },
          { internalType: "uint256", name: "lastweek", type: "uint256" },
          { internalType: "uint256", name: "step", type: "uint256" },
          { internalType: "uint256", name: "pending_voucher", type: "uint256" },
          { internalType: "bool", name: "exists", type: "bool" },
          { internalType: "bytes32", name: "data", type: "bytes32" },
        ],
        internalType: "struct UsersStruct.User",
        name: "parent",
        type: "tuple",
      },
      {
        components: [
          { internalType: "uint256", name: "id", type: "uint256" },
          {
            components: [
              { internalType: "uint256", name: "left", type: "uint256" },
              { internalType: "uint256", name: "right", type: "uint256" },
              { internalType: "uint256", name: "all_left", type: "uint256" },
              { internalType: "uint256", name: "all_right", type: "uint256" },
              { internalType: "uint256", name: "dir", type: "uint256" },
              { internalType: "uint256", name: "level", type: "uint256" },
              { internalType: "uint256", name: "summ", type: "uint256" },
              {
                internalType: "uint256",
                name: "dnm_withdraw",
                type: "uint256",
              },
            ],
            internalType: "struct UsersStruct.BusinessValue",
            name: "bv",
            type: "tuple",
          },
          {
            components: [
              { internalType: "uint256", name: "date", type: "uint256" },
              { internalType: "uint256", name: "order_id", type: "uint256" },
              { internalType: "uint256", name: "bv_level", type: "uint256" },
            ],
            internalType: "struct UsersStruct.LastOrder",
            name: "last_order",
            type: "tuple",
          },
          { internalType: "uint256", name: "depth", type: "uint256" },
          {
            internalType: "uint256",
            name: "pending_withdraw",
            type: "uint256",
          },
          { internalType: "uint256", name: "levelup_count", type: "uint256" },
          { internalType: "uint256", name: "lastweek", type: "uint256" },
          { internalType: "uint256", name: "step", type: "uint256" },
          { internalType: "uint256", name: "pending_voucher", type: "uint256" },
          { internalType: "bool", name: "exists", type: "bool" },
          { internalType: "bytes32", name: "data", type: "bytes32" },
        ],
        internalType: "struct UsersStruct.User",
        name: "child",
        type: "tuple",
      },
    ],
    name: "isChildOfParent",
    outputs: [
      { internalType: "bool", name: "", type: "bool" },
      { internalType: "uint8", name: "", type: "uint8" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isDev",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "last_withdrawal_time",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "level_up_data_index",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "order_id",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint256", name: "bv_value", type: "uint256" },
          { internalType: "uint256", name: "sv_value", type: "uint256" },
          { internalType: "uint256", name: "seller_token", type: "uint256" },
          { internalType: "address", name: "seller_address", type: "address" },
          { internalType: "bytes32", name: "data", type: "bytes32" },
        ],
        internalType: "struct Payments.PaymentData",
        name: "_payment",
        type: "tuple",
      },
      { internalType: "address", name: "parent_addr", type: "address" },
    ],
    name: "payment",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint256", name: "bv_value", type: "uint256" },
          { internalType: "uint256", name: "sv_value", type: "uint256" },
          { internalType: "uint256", name: "seller_token", type: "uint256" },
          { internalType: "address", name: "seller_address", type: "address" },
          { internalType: "bytes32", name: "data", type: "bytes32" },
        ],
        internalType: "struct Payments.PaymentData",
        name: "_payment",
        type: "tuple",
      },
      { internalType: "uint256", name: "parent_id", type: "uint256" },
    ],
    name: "payment",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint256", name: "bv_value", type: "uint256" },
          { internalType: "uint256", name: "sv_value", type: "uint256" },
          { internalType: "uint256", name: "seller_token", type: "uint256" },
          { internalType: "address", name: "seller_address", type: "address" },
          { internalType: "bytes32", name: "data", type: "bytes32" },
        ],
        internalType: "struct Payments.PaymentData",
        name: "_payment",
        type: "tuple",
      },
      { internalType: "address", name: "payer_user", type: "address" },
      { internalType: "address", name: "from_user", type: "address" },
      { internalType: "uint256", name: "parent_id", type: "uint256" },
    ],
    name: "paymentFrom",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint256", name: "bv_value", type: "uint256" },
          { internalType: "uint256", name: "sv_value", type: "uint256" },
          { internalType: "uint256", name: "seller_token", type: "uint256" },
          { internalType: "address", name: "seller_address", type: "address" },
          { internalType: "bytes32", name: "data", type: "bytes32" },
        ],
        internalType: "struct Payments.PaymentData",
        name: "_payment",
        type: "tuple",
      },
      { internalType: "address", name: "payer_user", type: "address" },
      { internalType: "address", name: "from_user", type: "address" },
      { internalType: "address", name: "parent_addr", type: "address" },
    ],
    name: "paymentFrom",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "spender", type: "address" }],
    name: "revokeAllowance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    name: "sellerWithdrawDNM",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "seller_id",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "setAllowance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "cal", type: "address" }],
    name: "setCalculator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "switchToProduction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    name: "userWithdrawDNM",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    name: "userWithdrawDNMVoucher",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    name: "userWithdrawWeekUVM",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "user_id",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "withdraw_amount", type: "uint256" },
      { internalType: "address", name: "withdrawal_address", type: "address" },
    ],
    name: "withdrawWithDao",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;
